import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useBreadcrumb } from '../../contexts/BreadcrumbContext';
import { Home } from '@mui/icons-material';
import styles from './OpportunityDetailsPage.module.css';
import Breadcrumb, { BreadcrumbItem } from '../../components/Breadcrumb/Breadcrumb';

const OpportunityDetailsPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { setBreadcrumbs } = useBreadcrumb();
  // Get opportunity data (from state or fetch)
  const opportunity = { id, title: 'Example Opportunity' }; // Replace with actual data

  useEffect(() => {
    setBreadcrumbs([
      { label: 'Home', path: '/', icon: <Home sx={{ fontSize: 16 }} /> },
      { label: 'Oportunidades', path: '/opportunities' },
      { label: opportunity.title },
    ]);

    return () => {
      setBreadcrumbs([{ label: 'Home', path: '/', icon: <Home sx={{ fontSize: 16 }} /> }]);
    };
  }, [opportunity, setBreadcrumbs]);

  const breadcrumbItems: BreadcrumbItem[] = [
    {
      label: 'Home',
      path: '/',
      icon: <Home sx={{ fontSize: 16 }} />,
    },
    {
      label: 'Oportunidades',
      path: '/opportunities',
    },
    {
      label: 'test', // Assuming opportunity is your data object
    },
  ];

  return (
    <>
      <Breadcrumb items={breadcrumbItems} />
      <div className={styles.container}>
        <div className={styles.header}>
          <h1>Opportunity Details</h1>
        </div>
        <div className={styles.content}>
          <p>This is a placeholder for the Opportunity Details page.</p>
        </div>
      </div>
    </>
  );
};

export default OpportunityDetailsPage;
